<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="customer-main-sidebar" position="left" lockedOpen="gt-md">
        <customer-main-sidebar></customer-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">


                        <ngx-datatable-column name="{{'Created at' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.createdAt | date:'dd.MM.yyyy H:mm:ss':'UTC': 'pl'}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Customer' | translate}}" prop="user">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.user">
                                    <a *appIsGranted="['Customers', 'READ']" routerLink="/customers/details/{{row.user.id}}">
                                        {{row.user.firstName}} {{row.user.lastName}}
                                    </a>
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Items' | translate}}" prop="items">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <ul>
                                    <li *ngFor="let item of row.items">{{item.quantity}} x {{item.voucherTemplate.name}}</li>
                                </ul>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Paid' | translate}}" prop="user">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.paid">{{'Yes'|translate}}</span>
                                <span *ngIf="!row.paid">{{'No'|translate}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Payment' | translate}}" prop="externalPaymentId">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.externalPaymentStatement">
                                    {{row.externalPaymentStatement}} ({{row.externalPaymentId}})
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Payment date' | translate}}" prop="externalPaymentId">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.onlinePaymentDate | date:'dd.MM.yyyy H:mm:ss':'UTC': 'pl'}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Paid amount' | translate}}" prop="externalPaymentId">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.paidAmount">{{row.paidAmount/100}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
